export const t = {
  // Headings — 16px base, Geist Sans
  pageTitle: "text-2xl font-semibold tracking-tight",   // 24px/600
  sectionTitle: "text-xl font-semibold",                 // 20px/600

  // Content — inherits 16px/1.5 from body
  body: "",

  // Secondary
  meta: "text-sm",                                        // 14px/400
  metaMedium: "text-sm font-medium",                      // 14px/500

  // Labels & badges
  label: "text-xs font-semibold uppercase tracking-wide text-muted-foreground", // 12px/600
  caption: "text-xs",                                     // 12px/400

  // Display
  score: "text-4xl font-bold",                            // 36px/700 (guide: score display)
} as const;
